module.exports = __webpack_public_path__ + "static/img/collage 1.e0ac2aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collage 1.jpg
// module id = vXyi
// module chunks = 0